import {
  CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/CancelTopicCreationModali18nConstants';

export const CANCEL_TOPIC_CREATION_MODAL_I18N_EN = {
  [CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS.modal_title]:                       "Cancel Topic Creation",
  [CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS.paragraph_1]:                       "The topic cannot be saved if less than one file has been uploaded.",
  [CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS.paragraph_2]:                       "Proceed to cancel topic creation?",
  [CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS.cancel_topic_creation_button_text]: "Cancel Topic Creation",
  [CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS.back_button_text]:                  "Back"
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/cancel_topic_creation_modal.i18n.en.js